import { useEffect, useState } from 'react';
import Iconify from 'src/components/iconify';
import SerpModal from './SerpModal';
import { SerpModalProps } from '../types';

interface SerpModalButtonProps {
    gcsUrl?: string | null;
    deviceType?: string | null;
    iconType: 'mobile' | 'desktop';
    searchTerm?: string;
}

function SerpModalButton({ gcsUrl, deviceType, iconType, searchTerm }: SerpModalButtonProps) {
    const [serpModalOpen, setSerpModalOpen] = useState(false);
    const [serpPayload, setSerpPayload] = useState<SerpModalProps['payload']>({
        startDate: '2025-08-02',
        endDate: '2025-08-31',
        keywords: ['polene'],
        countries: 'Australia',
        devices: deviceType || 'DESKTOP',
        workspaceId: 48,
        offset: 0,
        pageSize: 5,
        platform: 'Google',
        gcsUrl: gcsUrl || '',
        searchTerm: searchTerm || '',
        deviceType: iconType
    });

    // Update payload when search term changes
    useEffect(() => {
        setSerpPayload(prev => ({
            ...prev,
            searchTerm: searchTerm || ''
        }));
    }, [searchTerm]);

    // Validate GCS URL
    const hasValidGcsUrl = gcsUrl &&
        typeof gcsUrl === 'string' &&
        gcsUrl.trim() !== '' &&
        gcsUrl !== 'null' &&
        gcsUrl !== 'undefined' &&
        gcsUrl.startsWith('gs://');

    return (
        <>
            <Iconify
                icon={iconType === 'mobile' ? 'solar:smartphone-outline' : 'solar:laptop-outline'}
                fontSize="small"
                height={16}
                width={16}
                onClick={hasValidGcsUrl ? () => setSerpModalOpen(true) : undefined}
                sx={{
                    cursor: hasValidGcsUrl ? 'pointer' : 'not-allowed',
                    opacity: hasValidGcsUrl ? 1 : 0.3,
                    color: hasValidGcsUrl ? 'inherit' : 'text.disabled',
                    '&:hover': {
                        opacity: hasValidGcsUrl ? 0.8 : 0.3
                    }
                }}
            />
            {hasValidGcsUrl && (
                <SerpModal
                    open={serpModalOpen}
                    onClose={() => setSerpModalOpen(false)}
                    payload={serpPayload}
                    deviceType={iconType}
                />
            )}
        </>
    );
}

export default SerpModalButton;


